
import rules from "../mixins/rules.mixin.js";

export default {
  name: "CriarUsuario",
  mixins: [rules],

  data: () => ({
    dialog: false,
    valid: false,
    cpf: "",
    login: "",
    unidade: "",
    password: "",
    unidades: [
      { id: "0", name: "ALCÂNTARA" },
      { id: "3", name: "ILHA" },
    ],
  }),

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.send();
      }
    },

    send() {
      this.$http
        .post(`/usuario`, {
          cpf: this.cpf,
          login: this.login,
          unidade: this.unidade,
          password: this.password,
        })
        .then(() => {
          this.$emit("created");
          this.dialog = false;
          this.cpf = "";
          this.login = "";
          this.nome = "";
          this.password = "";
        })
        .catch((err) => {
          alert(err.response.data);
        });
    },
  },
};
